export const PILL_TYPES = {
  CHIP: 'chip',
  PILL: 'pill',
};

export const PILL_VARIANT = {
  OUTLINED: 'outlined',
  REGULAR: 'regular',
};
